import cx from 'classnames';
import { Link } from 'react-router-dom';

export type CheckoutBreadcrumb = 'allProducts' | 'mySelection' | 'checkout';

interface Props {
  to: string;
  isSelected: boolean;
  isActive: boolean;
  label: string;
  dataTestId?: string;
  onClick?: VoidFunction;
}
export const BreadcrumbsItem = ({ to, label, isActive, isSelected, onClick, dataTestId }: Props) => {
  return (
    <li className="cursor-default text-xs uppercase tracking-wider text-neutral-60" data-testid={dataTestId}>
      {isActive ?
        <Link to={to} className={cx({ 'font-bold text-neutral-20 underline': isSelected })} onClick={onClick}>
          {label}
        </Link>
      : <span>{label}</span>}
    </li>
  );
};
